import { State } from "./types";

export default function defaultState(overrides: object = {}): State {
  return {
    errors: [],
    history: [],
    ...overrides,
  };
}
